export default "__VITE_ASSET__CENSgZp2__"